import React from 'react';
import { Grid, Typography } from '@mui/material';
import { toCurrency } from '../../../utils/currency/currency.utils';
import { CurrencyCode, CurrencyFormat } from '../../../utils/currency/currency.constants';

interface IProps {
  alignItems?: 'center' | 'flex-start';
  direction?: 'row' | 'column';
  flipSubtext?: boolean;
  fontSize?: string;
  subText?: string;
  text: string;
  value: number;
}

export const DialTotal: React.FC<IProps> = (props) => {
  const { alignItems = 'center', direction = 'row', fontSize = '1rem' } = props;

  return (
    <Grid
      item={true}
      container={true}
      direction={direction}
      alignItems={alignItems}
      justifyContent={'space-between'}
      marginY={1}
    >
      <Typography
        fontWeight={'bold'}
        fontSize={fontSize}
      >
        {props.text}
      </Typography>

      <Grid item={true}>
        <Grid
          container={true}
          alignItems={'center'}
          flexWrap={'wrap-reverse'}
        >
          {props.subText && props.flipSubtext && (
            <Typography
              fontSize={'1rem'}
              align={'right'}
              marginRight={2}
              fontStyle={'italic'}
            >
              {props.subText}
            </Typography>
          )}

          <Typography
            fontWeight={'bold'}
            fontSize={fontSize}
            align={'right'}
          >
            $
            {toCurrency(props.value, {
              currencyCode: CurrencyCode.USD,
              fractionDigits: 2,
              format: CurrencyFormat.None,
            })}
          </Typography>

          {props.subText && !props.flipSubtext && (
            <Typography
              fontSize={'1rem'}
              align={'right'}
              marginRight={2}
              fontStyle={'italic'}
            >
              {props.subText}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

DialTotal.displayName = 'DialTotal';
